/**
 * 機能 4: 電話案内ブロックの店舗連動
 *
 * 店舗 select の選択に合わせて、ページ内の電話案内ブロック
 * （_telephone-inquiry / [data-telephone-inquiry]）の電話番号と定休日を
 * 選択店舗のものに書き換える。
 *
 * - 店舗未選択に戻った場合や、店舗側の値が空の場合は初期表示（会社共通）の値に戻す
 * - URL パラメータ（shop_id / lat・lng）による自動選択にも change イベント経由で追従する
 */

/**
 * @param {Object} params
 * @param {HTMLSelectElement} params.shopNative - 店舗 select の実 select 要素
 * @param {Object.<string, {tel: ?string, holiday: ?string}>} params.shopContactMap - 店舗 ID → 電話番号・定休日
 * @returns {void}
 */
export const setupShopContactSync = ({ shopNative, shopContactMap }) => {
    // 対応表が無ければ機能を無効化
    if (Object.keys(shopContactMap).length === 0) return;

    const blocks = document.querySelectorAll("[data-telephone-inquiry]");
    if (blocks.length === 0) return;

    // 初期表示（会社共通）の値を控えておき、店舗未選択時のフォールバックにする
    const defaults = new Map();
    blocks.forEach((block) => {
        defaults.set(block, {
            tel: block.querySelector("[data-telephone-inquiry-tel]")?.textContent ?? "",
            closed: block.querySelector("[data-telephone-inquiry-closed-text]")?.textContent ?? "",
        });
    });

    /**
     * 現在の店舗選択に合わせて全ブロックを更新する。
     */
    const apply = () => {
        const contact = shopContactMap[shopNative.value] ?? null;

        blocks.forEach((block) => {
            const fallback = defaults.get(block);
            const tel = contact?.tel || fallback.tel;
            const closed = contact?.holiday || fallback.closed;

            block.setAttribute("href", `tel:${tel}`);

            const telEl = block.querySelector("[data-telephone-inquiry-tel]");
            if (telEl) telEl.textContent = tel;

            const closedWrapEl = block.querySelector("[data-telephone-inquiry-closed]");
            const closedTextEl = block.querySelector("[data-telephone-inquiry-closed-text]");
            if (closedTextEl) closedTextEl.textContent = closed;
            if (closedWrapEl) closedWrapEl.toggleAttribute("hidden", !closed);
        });
    };

    shopNative.addEventListener("change", apply);

    // バリデーションエラー等でサーバー側から選択済みで描画された場合に反映
    if (shopNative.value) apply();
};
